<template>
  <svg id="icon-chevron-right" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-162.5-12.5h554v512h-554z"/>
      <path d="M6.85 5.983A1.167 1.167 0 0 1 8.483 4.35l4.667 4.667c.445.453.445 1.18 0 1.633l-4.667 4.667a1.167 1.167 0 0 1-1.633-1.634l3.838-3.85-3.85-3.85h.012z" fill="currentColor" fill-rule="nonzero"/>
    </g>
  </svg>
</template>
